import { useState } from "react";
import { PreferedCard } from "../card";
import { Skeleton } from "@mui/material";
import i18n from "../../i18n";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Balance() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [balance, setBalance] = useState(null);

    async function getTotalUsers() {
        var getMore = true;
        var nextPage = null;

        const stripe = require('stripe')(`${process.env.REACT_APP_STRIPE}`);
        const startDate = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 30)).getTime().toString();
        const startDateStr = startDate.substring(0, startDate.length - 3)
        const endDate = new Date(new Date().getTime()).getTime().toString();
        const endDateStr = endDate.substring(0, endDate.length - 3)
        var balance;

        while (getMore) {
            var totalAmount = 0;

            console.log(`created>=${startDateStr} AND created<=${endDateStr} AND status:'succeeded'`);
            if (nextPage !== null) {
                balance = await stripe.paymentIntents.search({
                    query: `created>=${startDateStr} AND created<=${endDate} AND status:'succeeded'`,
                    limit: 100,
                    page: nextPage,
                });
            } else {
                balance = await stripe.paymentIntents.search({
                    query: `created>=${startDateStr} AND created<=${endDateStr} AND status:'succeeded'`,
                    limit: 100,
                });
            }
            console.log(balance);

            for (const paymentIntent of balance.data) {
                totalAmount += paymentIntent.amount;
            }
            
            if (balance.next_page !== null) {
                nextPage = balance.next_page;
            } else {
                getMore = false;
            }
        }

        getMore = true;
        nextPage = null;
        while (getMore) {
            if (nextPage === null) {
                console.log({
                    created: {
                        gte: startDateStr,
                        lte: endDateStr,
                    },
                    limit: 100,
                })
                balance = await stripe.refunds.list({
                    created: {
                        gte: startDateStr,
                        lte: endDateStr,
                    },
                    limit: 100,
                });
            } else {
                console.log({
                    created: {
                        gte: startDateStr,
                        lte: endDateStr,
                    },
                    starting_after: nextPage,
                    limit: 100,
                })
                balance = await stripe.refunds.list({
                    created: {
                        gte: startDateStr,
                        lte: endDateStr,
                    },
                    starting_after: nextPage,
                    limit: 100,
                });
            }
            console.log(balance);

            for (const refound of balance.data) {
                totalAmount -= refound.amount;
            }

            if (balance.has_more) {
                nextPage = balance.data[balance.data.length - 1].id;
            } else {
                getMore = false;
            }
        }

        setBalance(totalAmount);
    }

    if (balance === null) {
        getTotalUsers();
    }
    
    return <PreferedCard title={t('homePage.balance')} subtitle={t('homePage.balanceDesc')} onClick={() => {navigate('/balance')}}>
        {balance !== null
            ? <h1 style={{margin: 0, color: 'var(--data-color)'}}>{(balance/100).toLocaleString(i18n.resolvedLanguage, {minimumFractionDigits:2, maximumFractionDigits:2})} €</h1>
            : <Skeleton variant="rounded" width={'100%'} height={60} />}
    </PreferedCard>;
}